import React from 'react';

const CircleComponent: React.FC<{color: string}> = ({color}) => {
  return (
    <div
      style={{
        backgroundColor: color,
        height: '10px',
        aspectRatio: '1',
        borderRadius: '50%'
      }}
    >
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 100 100"
      >
        <circle cx="50" cy="50" r="40" fill={color} />
      </svg> */}
    </div>
  );
};

export default CircleComponent;
